module.exports = __webpack_public_path__ + "sounds/plop.mp3?ea9c7820";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/plop.mp3
// module id = 717
// module chunks = 7